import { render, staticRenderFns } from "./resource-publish-box-form.vue?vue&type=template&id=fa365c7a"
import script from "./resource-publish-box-form.vue?vue&type=script&lang=ts"
export * from "./resource-publish-box-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports